import emojiRegexFn from 'emoji-regex';

const emojiRegex = emojiRegexFn();

export const emailReg =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

// eslint-disable-next-line no-useless-escape, max-len
export const validateEmail = value => emailReg.test(value);
export const validateEmojiRegex = value => !new RegExp(emojiRegex).test(value);
export const EmojiRegex = new RegExp(emojiRegex);
